exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit_pwd {\n  padding-top: 0.1rem;\n}\n.edit_pwd .list .weui-cell {\n  padding: 0.15rem;\n}\n.edit_pwd .list .weui-cell ::-webkit-input-placeholder {\n  /* WebKit, Blink, Edge */\n  color: #BABACE;\n  font-size: 0.16rem !important;\n}\n.edit_pwd .list .weui-cell .weui-label {\n  font-size: 0.16rem !important;\n}\n.edit_pwd .list .weui-cell input {\n  font-size: 0.16rem !important;\n}\n.edit_pwd .list .weui-cell:before {\n  left: 96px;\n}\n.edit_pwd .button {\n  width: 100%;\n  padding: 0 0.15rem;\n}\n", ""]);

// exports
